// Shared styling helpers for the static_text field type (Aug 2026):
// optional border + pasted-image alignment. Used by the form builder,
// form view renderers, note dialog, and mirrored in the PDF generator.
export const STATIC_TEXT_THICKNESS_PX = { thin: 1, medium: 2, thick: 4 };

export const staticTextBorderStyle = (field) => {
  if (!field?.borderEnabled) return {};
  const t = field.borderThickness;
  const px = STATIC_TEXT_THICKNESS_PX[t] || parseInt(t, 10) || 1;
  return {
    border: `${px}px solid ${field.borderColor || '#d1d5db'}`,
    borderRadius: '6px',
    padding: '10px 12px',
  };
};

export const staticTextImageClass = (field) => {
  const a = field?.imageAlign;
  return a === 'left' || a === 'center' || a === 'right' ? `st-img-${a}` : '';
};
